import { render, staticRenderFns } from "./UsersPendingActivationFilters.vue?vue&type=template&id=0bc0663b"
import script from "./UsersPendingActivationFilters.vue?vue&type=script&lang=js"
export * from "./UsersPendingActivationFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports